<script setup lang="ts">
import FadeFlipTransition from '@shared/animation/transitions/FadeFlipTransition/FadeFlipTransition.vue';
import { FontAwesomeIcon } from '@shared/plugin/icons';

export interface FormStatusProps {
  error?: boolean;
  valid: boolean;
  active?: boolean;
  iconSize?:
    | 'lg'
    | 'xs'
    | 'sm'
    | '1x'
    | '2x'
    | '3x'
    | '4x'
    | '5x'
    | '6x'
    | '7x'
    | '8x'
    | '9x'
    | '10x';
}

const props = withDefaults(defineProps<FormStatusProps>(), {
  active: false,
  iconSize: undefined,
});
</script>

<template>
  <div class="inline-grid">
    <FadeFlipTransition>
      <FontAwesomeIcon
        width-auto
        :size="iconSize"
        icon="fas fa-check-circle"
        :class="[
          'col-end-1 row-end-1',
          {
            'text-primary': !active && !props.error,
            'text-primary-dark': active && !props.error,
            'text-orange-700': props.error,
          },
        ]"
        v-if="valid"
      />
      <FontAwesomeIcon
        width-auto
        :size="iconSize"
        icon="far fa-circle"
        :class="[
          'col-end-1 row-end-1 rounded-full bg-white',
          {
            'text-grey': !props.error,
            'text-orange-700': props.error,
          },
        ]"
        v-else
      />
    </FadeFlipTransition>
  </div>
</template>
